import * as React from 'react';
import { Tokenizer } from '@fnv-core/tokens';
import { Slug } from '@fnv-core/utils';
import { FormControlProps } from '../interfaces/FormControlProps';
import { FormControlHelpers } from './helpers/FormControlHelpers';
import { LabelAndPopover } from './components/label-and-popover';
import { PropertyHelpers } from '../helpers/PropertyHelpers';
import { FormLabelHelpers } from "./helpers/FormLabelHelpers";

class LinkField extends React.Component<FormControlProps> {
    constructor(props: FormControlProps) {
        super(props);
    }

    getLinkElements(field: any) {
        let fieldValue: string = field.value != null ? field.value : "";

        let format = this.props.formFieldDefinition.defaultValue != "" ? this.props.formFieldDefinition.defaultValue : "{0}"; 

        let formatParts = format.split('|');

        if (fieldValue == '') {
            fieldValue = ' ';
        }

        let link: string = '';
        let linkText: string = '';
        if (formatParts.length >= 2) {
            link = formatParts[1];
            linkText = formatParts[0];
        }
        if (formatParts.length == 1) {
            link = formatParts[0];
            linkText = formatParts[0];
        }

        link = Tokenizer.replaceTokens(link, [fieldValue]);
        linkText = Tokenizer.replaceTokens(linkText, [fieldValue]);

        link = FormControlHelpers.replaceBracketFieldsWithValues(this, link);
        linkText = FormControlHelpers.replaceBracketFieldsWithValues(this, linkText);

        return {
            link: link,
            linkText: linkText
        };
    }

    render() {
        let { link, linkText } = this.getLinkElements(this.props.field);
        let additionalCssClass = "";
        if (this.props.formFieldDefinition.fieldCssClass !== undefined) {
            additionalCssClass += " " + this.props.formFieldDefinition.fieldCssClass;
        }
        return (
            <div className={'form-group' + this.props.visibilityClass + ' ' + Slug.fromString(this.props.formFieldDefinition.name) + '-link-form-group' + additionalCssClass}>
                <LabelAndPopover 
                    fieldId={PropertyHelpers.getFieldID(this.props)} 
                    label={FormLabelHelpers.getFieldLabel(this)}
                    explanation={this.props.formFieldDefinition.explanation}
                    hasPopover={this.props.formFieldDefinition.hasPopover}                    
                ></LabelAndPopover>
                <div className="input-group">
                    <a className="form-control__link"
                            href={link}
                            id={this.props.formFieldDefinition.name}
                            ref={this.props.formFieldDefinition.name}
                            title={linkText}
                        >{linkText}</a>
                </div>
            </div>
        );
    }
}

export { LinkField };
